import PropTypes from 'prop-types';

// @mui
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';

// components
import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';

import PlanBadge from './plan-badge';

// ----------------------------------------------------------------------

export const PLAN_5_MESSAGE =
  'Esta é uma funcionalidade do plano 5.0, tenha rastreabilidade e controle total da sua ' +
  'concreteira com sensores de silo, sensor de compressor e o dobro de tokens na Kartrak IA. ' +
  'Caso esteja no plano padrão, esta tela ficará disponível por apenas alguns dias, faça ' +
  'upgrade e continue aproveitando';

// Aviso no topo das telas do plano 5.0 (estoque, controle de silos).
export default function PlanNotice({ message = PLAN_5_MESSAGE }) {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <Alert
        severity="success"
        icon={<Iconify icon="solar:crown-star-bold-duotone" width={24} />}
        action={<PlanBadge sx={{ mt: 0.25 }} />}
        sx={{ mb: 3, alignItems: 'center' }}
      >
        {message}
      </Alert>
    </Container>
  );
}

PlanNotice.propTypes = {
  message: PropTypes.string,
};
